import gameNames from 'a/hub/data/GameIds';
import { ACTION_TYPES } from 'a/mindTheGap/data/constants';

const initialState = { alexState: 0 };

const alexReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.MIND_THE_GAP) {
    return state;
  }

  switch (action.type) {
    case ACTION_TYPES.SET_ALEX_INACTIVE:
      return { ...state, alexState: 0 };
    case ACTION_TYPES.SET_ALEX_SPEAKING:
      return { ...state, alexState: 2 };
    default:
      return state;
  }
};

export default alexReducer;
